import React from 'react';
import { useTheme } from '../../context/ThemeContext';

const ConfirmationModal = ({
  isOpen,
  onConfirm,
  onCancel,
  title = 'Confirm Action',
  message = 'Are you sure you want to proceed?',
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  confirmButtonClass = 'btn-glass-accent',
  isLoading = false
}) => {
  const { isDark } = useTheme();

  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-80 backdrop-blur-md flex items-center justify-center p-4 z-50"
      onClick={onCancel}
    >
      <div 
        className="glass-modal rounded-2xl max-w-md w-full animate-scale-in"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="p-6">
          <h2 className={`heading-mono text-xl mb-4 ${isDark ? 'text-white' : 'text-gray-800'}`}>
            {title}
          </h2>
          
          <div className={`text-mono text-sm mb-6 ${isDark ? 'text-gray-300' : 'text-gray-700'}`}>
            {typeof message === 'string' ? <p>{message}</p> : message}
          </div>
          
          <div className="flex gap-3">
            <button
              onClick={onCancel}
              disabled={isLoading}
              className="flex-1 btn-glass px-4 py-2 rounded-lg text-mono font-medium disabled:opacity-50"
            >
              {cancelText}
            </button>
            <button
              onClick={onConfirm}
              disabled={isLoading}
              className={`flex-1 px-4 py-2 rounded-lg text-mono font-medium disabled:opacity-50 ${confirmButtonClass}`}
            >
              {isLoading ? (
                <div className="flex items-center justify-center gap-2">
                  <div className="glass-spinner w-4 h-4"></div>
                  <span>{confirmText}</span>
                </div>
              ) : (
                confirmText
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;